import { Grid, Panel, Row } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
import { FontStylePanel } from './FontStylePanel';
import { TextSample } from './TextSample';
import { characters, longText, longTextInlineStyle } from './TextSpecimen';
const TextFontPanelInternal = ({ fontStyles, name }) => {
    return (React.createElement(Grid, { spacing: "1rem", fullWidth: true },
        React.createElement(Row, null,
            React.createElement(Panel, null,
                React.createElement(FontStylePanel, { name: `${name} / plain` },
                    React.createElement(TextSample, { fontStyles: fontStyles }, characters),
                    React.createElement(TextSample, { fontStyles: fontStyles }, longText))),
            React.createElement(Panel, null,
                React.createElement(FontStylePanel, { name: `${name} / inline styles` },
                    React.createElement(TextSample, { fontStyles: fontStyles, as: "div" }, longTextInlineStyle))))));
};
export const TextFontPanel = withUIETheme(TextFontPanelInternal);
//# sourceMappingURL=TextFontPanel.js.map